export class ImportStaffDataController {
    savedMatch: boolean = true;

    /* @ngInject */
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/import-staff-data/import-staff-data.controller.ts